import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IndicatorComponent } from '../indicator';
import { AlertLevel } from './alert.interface';
import { AlertModule } from './alert.module';
import { Component, Input } from '@angular/core';
import { AvatarModule } from '../avatar';

@Component({
    selector: 'lui-alert-lite',
    imports: [
        CommonModule,
        AlertModule,
        IndicatorComponent,
        MatIconModule,
        AvatarModule,
    ],
    template: `<lui-alert [level]="level">
    <lui-indicator [size]="52" *ngIf="!compact" luiAlertIcon
      ><mat-icon [svgIcon]="icon || defaultIcon"></mat-icon
    ></lui-indicator>
    <lui-alert-icon
      *ngIf="compact"
      luiAlertIcon
      [size]="24"
      [icon]="icon || defaultIcon"
    ></lui-alert-icon>
    <div [class.mat-small]="compact">
      <div [innerHTML]="content"></div>
      <ng-content></ng-content>
    </div>
  </lui-alert>`
})
export class AlertLiteComponent {
  @Input() icon!: string;
  @Input() get level(): AlertLevel {
    this.defaultIcon;
    return this._level;
  }
  set level(value: AlertLevel) {
    this.defaultIcon = this.iconMap[value] || 'i';
    this._level = value;
  }
  _level: AlertLevel = 'info';
  @Input() content!: string;
  @Input() compact = false;

  defaultIcon = 'i';

  private iconMap = {
    info: 'i',
    elevated: 'i',
    success: 'tick',
    danger: 'exclaim',
    'info-solid': 'i',
    'elevated-solid': 'i',
    'success-solid': 'success',
    'danger-solid': 'exclaim',
  };
}
